'use client'
import { createSession } from '@/actions/auth';
import useUserContext from '@/hooks/useUserContext';
import { Customer } from '@/types/Auth';
import { getCookie } from 'cookies-next';
import React, { useEffect } from 'react';

// import { Container } from './styles';

const SetCustomer: React.FC<{ customer: Customer, lang: Locale }> = ({ customer, lang }) => {
  const { setLoggedCustomer } = useUserContext();
  const session = getCookie('PHPSESSID');

  useEffect(() => {
    if (!session) {
      createSession();
    }
    setLoggedCustomer(customer)
  }, [])

  return <></>;
}

export default SetCustomer;